import React, { Component } from 'react';
import { Slider } from '@cimpress/react-components';

export default class SliderDemo extends Component {
  state = {
    slider1: 0,
    slider2: 100,
    slider3: 0,
    slider4: 30,
  };

  onSelect = variable => value => {
    this.setState({ [variable]: value });
  };

  render() {
    const { slider1, slider2, slider3, slider4 } = this.state;
    return (
      <div className="row">
        <div className="col-md-3">
          <Slider label="Default Slider" value={slider1} onSelect={this.onSelect('slider1')} />
        </div>
        <div className="col-md-3">
          <Slider
            label="Variable range and increment"
            min={50}
            max={150}
            increment={2}
            value={slider2}
            onSelect={this.onSelect('slider2')}
          />
        </div>
        <div className="col-md-3">
          <Slider
            label="Negative numbers and decimals"
            min={-1}
            max={1}
            increment={0.01}
            value={slider3}
            onSelect={this.onSelect('slider3')}
          />
        </div>
        <div className="col-md-3">
          <Slider label="Disabled Slider" disabled={true} value={slider4} onSelect={this.onSelect('slider4')} />
        </div>
      </div>
    );
  }
}
